import React from "react"
import { Button } from "./style"
import NavbarDropdown from "../Navbar/NavbarDropdown"

const ButtonComponent = ({
  width,
  height,
  padding,
  text,
  background,
  border,
  color,
  onClick,
  className,
  icon,
  dropdown = false,
}) => {
  return dropdown ? (
    <NavbarDropdown icon={icon} onClick={onClick} />
  ) : (
    <Button
      padding={padding}
      width={width}
      height={height}
      background={background}
      border={border}
      color={color}
      onClick={onClick}
      className={className}
    >
      {icon ? <span className="text-md px-1">{icon}</span> : ""}
      {text}
    </Button>
  )
}

export default ButtonComponent
